/**
 * Network Enforcement Mode Banner — Phase 1c.2
 * Displays for 24h after a soft↔hard mode flip. Read-only.
 */
import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { getEnforcementModeBanner } from "@/data/contractor/networkExecution";

export function EnforcementModeBanner() {
  const [banner, setBanner] = useState(() => getEnforcementModeBanner());

  useEffect(() => {
    const id = setInterval(() => setBanner(getEnforcementModeBanner()), 60_000);
    return () => clearInterval(id);
  }, []);

  if (!banner) return null;
  const isHard = banner.mode === "hard";
  return (
    <div
      data-testid="enforcement-mode-banner"
      className={`mb-3 flex items-start gap-2 rounded-md border px-3 py-2 text-xs ${
        isHard
          ? "border-destructive/40 bg-destructive/10 text-destructive"
          : "border-warning/40 bg-warning/10 text-warning"
      }`}
    >
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="space-y-0.5">
        <div className="font-medium">
          Network enforcement mode is now <span className="uppercase">{banner.mode}</span>.
        </div>
        <div className="opacity-80">
          {isHard
            ? "Recommended actions may auto-execute. Operator review still required for financial moves."
            : "Recommendations are advisory only — no automatic execution."}{" "}
          Banner clears at {new Date(banner.expiresAt).toLocaleString()}.
        </div>
      </div>
    </div>
  );
}
